import { getURL } from './utils'

const Tracker = function () {}

Tracker.prototype.track = function (tag) {
  const message = {
    tag: tag,
    path: window.location.pathname,
    hash: window.location.hash,
    site: "alpha.my.flexlink.io"
  }
  fetch(getURL('/api/v1/tracking'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(message)
  })
}

Tracker.prototype.init = function () {
  const callback = this.track;
  document.addEventListener('click', function (event) {
    const attr = 'data-tracking'
    let elem = event.target
    let level = 0
    let iter = 0
    let attribute = null
    while (elem && iter < 100) {
      iter += 1
      attribute = elem.getAttribute(attr)
      if (!attribute || attribute === '') {
        level += 1
        elem = elem.parentElement
        continue
      }
      break
    }
    if (!elem || !attribute || attribute === '') {
      return
    }
    callback(attribute);
  })
}

export default Tracker;